import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";
import LastSubcriptionSaga from "./DerniereSouscriptionList/saga";
import SasSaga from "./SasList/saga";
import DossierCompletSaga from "./DossierCompletList/saga";
import MontantInvestSaga from "./MontantInvestList/saga";
import DossierValideSaga from "./DossierValideList/saga";
import SyntheseAnnuelleSaga from "./SyntheseAnnuelle/saga";
import DernieresReservSaga from "./DernieresReserv/saga";
import InvestisseursSaga from "./Investisseurs/saga";
import DocumentationReglementaire from "./DocumentationReglementaire/saga";
import DerniersDocs from "./DerniersDocs/saga";
import SyntheseAnnee from "./SyntheseAnnée/saga";
export default function* rootSaga() {
  yield all([
    //public
    fork(DocumentationReglementaire),
    fork(SyntheseAnnee),
    fork(DerniersDocs),
    fork(InvestisseursSaga),
    fork(DernieresReservSaga),
    fork(LastSubcriptionSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(SasSaga),
    fork(DossierCompletSaga),
    fork(MontantInvestSaga),
    fork(DossierValideSaga),
    fork(SyntheseAnnuelleSaga),
  ]);
}
